module.exports = __webpack_public_path__ + "img/temp-live-tv-hardcoded.2db4dcfd.png";